import { render } from "./RegionAlarmStatusPieChart.vue?vue&type=template&id=ff091280"
import script from "./RegionAlarmStatusPieChart.vue?vue&type=script&lang=js"
export * from "./RegionAlarmStatusPieChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__